import { MutationInputError } from 'providers/graphql'

export const fixAttributeDuplicatePaths = (
  attribute: MutationInputError['attribute'],
): MutationInputError['attribute'] => attribute.split('.').slice(1).join('.')
